// @ts-strict-ignore
import type { useSnackBar } from '@usealloy/component-library';
import { routes } from '~/helpers/routes';

import {
  getNumberChildActions,
} from 'flow/service/actions';
import {
  removeAction,
  resetNodeAndConnectorState,
  setFocusedNodeId,
  setIsTagSwapMode,
} from 'flow/store/redux/slice';
import { createWorkflowHistoryThunk } from 'flow/store/redux/thunks';
import { changeDescription } from 'flow/store/redux/types';
import type { WorkflowNode } from 'flow/service/graph';
import { createUiEffectContext } from 'flow/service/history';
import { Operation } from 'flow/service/changelog/types';
import type { WorkflowState } from 'flow/store/redux/state';

import type { AppDispatch } from '~/store';

export function removeActionAndResetNodeState({
  addSnackBar,
  dispatch,
  isWorkflowHistoryOn,
  nodeId,
}: {
  addSnackBar: ReturnType<typeof useSnackBar>;
  dispatch: AppDispatch;
  isWorkflowHistoryOn: boolean;
  nodeId: WorkflowNode['id'];
}) {
  dispatch(createWorkflowHistoryThunk(
    () => dispatch(removeAction({ id: nodeId })),
    isWorkflowHistoryOn,
    {
      operation: Operation.Remove,
      uiEffectContext: createUiEffectContext(changeDescription.action, {
        publicId: nodeId,
      }),
    },
  ));

  addSnackBar({
    duration: 2000,
    title: 'Deleted the action.',
    type: 'success',
  });
  setTimeout(() => dispatch(resetNodeAndConnectorState()), 10);
}

export function defaultOnDeleteAction({
  addSnackBar,
  dispatch,
  isWorkflowHistoryOn,
  nodeId,
  workflowData,
  setNodeDeletionChildActionCounts,
}: {
  addSnackBar: ReturnType<typeof useSnackBar>;
  dispatch: AppDispatch;
  isWorkflowHistoryOn: boolean;
  nodeId: WorkflowNode['id'];
  workflowData: WorkflowState['workflowData'];
  setNodeDeletionChildActionCounts: React.Dispatch<React.SetStateAction<number>>;
}) {
  return function handler() {
    if (nodeId) {
      const childActionCounts = getNumberChildActions({
        actionPublicId: nodeId,
        workflowData,
      });

      if (childActionCounts > 0) {
        setNodeDeletionChildActionCounts(childActionCounts);
      } else {
        removeActionAndResetNodeState({
          addSnackBar,
          dispatch,
          isWorkflowHistoryOn,
          nodeId,
        });
      }
    }
  };
}

export function defaultOnSwapAction({
  dispatch,
  nodeId,
}: {
  dispatch: AppDispatch;
  nodeId: WorkflowNode['id'];
}) {
  return function handler() {
    dispatch(setFocusedNodeId(nodeId));
    dispatch(setIsTagSwapMode(true));
  };
}

export function defaultOnUpdateAction({
  onUpdateAction,
}: {
  onUpdateAction: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return function handler() {
    onUpdateAction(true);
  };
}

export function defaultOnViewListAction({
  nodeId,
  workflowData,
}: {
  nodeId: WorkflowNode['id'];
  workflowData: WorkflowState['workflowData'];
}) {
  return function handler() {
    const customListToken = workflowData.actions[nodeId]?.options?.custom_list_token?.value;
    if (customListToken) {
      window.open(`${routes.v3.dashboard.settings.custom_list_versions({ customListToken })}`, '_blank');
    }
  };
}
